class LoginCtrl {

    constructor($scope, $location, UserService, $routeParams, EVENTS, $window, $rootScope) {

        this.$scope = $scope;

        if(!!$routeParams.returnTo) {
            this.returnTo = $routeParams.returnTo;
        }
        else {
            this.returnTo = "/";
        }

        if("undefined" !== typeof $routeParams.error) {
            this.$scope.error = $routeParams.error;
        }

        if("undefined" !== typeof $routeParams.errorMessage) {
            this.$scope.errorMessage = $routeParams.errorMessage;
        }

        $scope.login = () => {
 
            let details = {
                email: $scope.auth.email, 
                password: $scope.auth.password
            };

            UserService.login(details)
                .then((response) => {

                    if('undefined' != typeof response.data.id) {                        
                        if (!~$rootScope.currentUser.securityRoles.indexOf('ADMIN')) {
                            $location.url('/users');
                        } else {
                            $location.url(this.returnTo);
                        }
                    }
                    else {
                        $scope.error = "LOGINFAILURE";
                        $scope.errorMessage = response.data.message;
                    }

                }, (response) => {
                        $scope.error = response.error;
                        $scope.errorMessage = response.message;
                });
        };


    }

}

angular.module("cpm")
    .controller("LoginCtrl", ['$scope', '$location', 'UserService', '$routeParams', 'EVENTS', '$window', '$rootScope', LoginCtrl]);

